import { WorkspaceRole, WorkspaceSeatType } from "./workspace-role";
import { z } from "zod";
export const WorkspaceInvitation = z.object({
    id: z.string(),
    email: z.string().email(),
    createdAt: z.coerce.date(),
    resentAt: z.coerce.date().nullish(),
    role: z.nativeEnum(WorkspaceRole),
    seatType: WorkspaceSeatType,
    workspaceId: z.string(),
    invitedBy: z.string(),
});
